<template>
  <section class="thing-single">
    <section-toggler :tabs="createReactLangSections"
                     v-if="thing.permissions"
                     class="toggler"
                     @toggle="toggleSec($event)"></section-toggler>
    <section-toggler :tabs="sectionsAssigned" v-else class="toggler"></section-toggler>
    <component :is="activeSection" :thing="thing" component=""></component>
  </section>
</template>

<script>
  import {mapState,mapMutations,mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../../../mixins/utils/loaderMixin";
  import {sectionsToggler} from "../../../../mixins/utils/sectionToggler";

  import thingSettings from './thingsSettings'
  import thingRights from './thingsRights'
  import thingRoles from './thingsRoles'
  import thingParameters from './thingParameters'

  export default {
    name: 'thingSingle',
    mixins: [tokenAndRoute, loaderMixin, sectionsToggler],
    components: {
      thingSettings,
      thingRights,
      thingRoles,
      thingParameters
    },
    data() {
      return {
        activeSection: thingSettings,
        sections: [],
        sectionsAssigned: [
          {
            id: 0,
            name: this.$t('things.sections.settings'),
            component: thingSettings,
            active: true
          }
        ]
      }
    },
    computed: {
      ...mapState({
        thing: state => state.things.device,
        projects: state => state.projects.allProjects,
      }),
      createReactLangSections() {
        return this.sections = [
          {
            id: 0,
            name: this.$t('things.sections.settings'),
            component: thingSettings,
            active: true
          },
          // {
          //   id: 1,
          //   name: this.$t('things.sections.rights'),
          //   component: thingRights,
          //   active: false
          // },
          {
            id: 2,
            name: this.$t('things.sections.roles'),
            component: thingRoles,
            active: false,
          },
          // {
          //   id: 3,
          //   name: 'Параметры',
          //   component: thingParameters,
          //   active: false
          // }
        ]
      },
    },
    watch: {
      thing() {
        if (!this.thingInProject()) {
          this.sections.splice(1, 1)
        }
        if (this.thing.permission_level < 4) {
          this.sections.splice(1, 1)
        }
      }
    },
    methods: {
      ...mapMutations({}),
      ...mapActions({}),
      thingInProject() {
        let flag = false
        let deviceFunc = (data) => {
          data.devices.forEach((device) => {
            if (device.id === this.thing.id) {
              flag = true
            }
          })
        }
        let projectFunc = (data) => {
          data.forEach((item) => {
            if (item.devices.length > 0) {
              item.devices.forEach((device) => {
                if (device.id === this.thing.id) {
                  flag = true
                }
                if (device.devices.length > 0) {
                  deviceFunc(device)
                }
              })
            }
          })
        }
        this.projects.forEach((project) => {
          if (project.items.length > 0) {
            projectFunc(project.items)
          }
        })
        return flag;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .toggler {
    padding: 0 20px;
    border-bottom: 1px solid $grey;
    width: 100%;
    margin: 20px 0px 30px;
  }

  .thing-single {
    min-height: calc(100vh - 140px  - 80px - 20px);;
  }

  .toggler {
    padding: 0 5px;
  }
</style>
